import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const PercentIcon = (props: IconProps) => (
  <IconBox {...props}>
    <g clipRule="evenodd" fillRule="evenodd">
      <path d="M59.403 4.59694c1.3886 1.38854 1.3886 3.63979 0 5.02832L9.62527 59.403c-1.38853 1.3886-3.63979 1.3886-5.02832 0-1.38853-1.3885-1.38853-3.6398 0-5.0283L54.3747 4.59694c1.3886-1.38853 3.6398-1.38853 5.0283 0z" />
      <path d="M12.4444 7.1111c-2.94547 0-5.33329 2.38782-5.33329 5.3333 0 2.9455 2.38782 5.3334 5.33329 5.3334 2.9456.00001 5.3334-2.38789 5.3334-5.33339 0-2.9455-2.3878-5.33331-5.3334-5.33331zM0 12.4444C0 5.57157 5.57157.00001 12.4444.00001c6.8729 0 12.4445 5.57156 12.4445 12.44441 0 6.8729-5.5716 12.4445-12.4445 12.4445C5.57157 24.88891 0 19.31731 0 12.44441z" />
      <path d="M51.5556 46.22221c-2.9456 0-5.3334 2.3878-5.3334 5.3333 0 2.9456 2.3878 5.3334 5.3334 5.3334 2.9455 0 5.3333-2.3878 5.3333-5.3334 0-2.9455-2.3878-5.3333-5.3333-5.3333zm-12.4445 5.3333c0-6.8728 5.5716-12.4444 12.4445-12.4444 6.8728 0 12.4444 5.5716 12.4444 12.4444 0 6.8729-5.5716 12.4445-12.4444 12.4445-6.8729 0-12.4445-5.5716-12.4445-12.4445z" />
    </g>
  </IconBox>
);

export default PercentIcon;
